import React from 'react';
import { Hero } from '../components/Hero';
import { ProductGrid } from '../components/ProductGrid';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream selection:bg-lavender selection:text-[#4A3B6B]" data-id="element-69">
      <Hero data-id="element-70" />
      <ProductGrid data-id="element-71" />
      <FinalCTA data-id="element-72" />
      <Footer data-id="element-73" />
    </main>;
}